<template>
  <div class="hello" id="detailDom">
    <RobotSocket ref="robotSocket" :nowTime='nowTime' @backSockertData='doSocker($event)' />
    <Head type='admin' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>

    <!-- 退出登陆提醒 -->
    <el-dialog :visible.sync="dialogVisible" width="30%" center>
      <div style="width: 100%;height: 100%;position: relative;">
        <img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">{{ languageJson.OperationTips }}</div>
        </div>
        <div
            style="position: absolute;width: 100%;top: 35%;font-size: 1.2vw;color: white;font-weight: 600;text-align: center;">
          {{ languageJson.ExitText }}</div>
        <div
            style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
          <div class="newBtn1" style="width: 40%;" @click="dialogVisible = false">{{ languageJson.Cancel }}</div>
          <div class="newBtn1 newBtn1do" style="width: 40%;" @click="getOut()">{{ languageJson.Exit }}</div>
        </div>
      </div>
    </el-dialog>

    <!-- 取消任务-->
    <el-dialog :visible.sync="cancelVisible" width="30%" center>
      <div style="width: 100%;height: 100%;position: relative;">
        <img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">操作确认</div>
        </div>
        <div style="position: absolute;width: 100%;top: 1%;font-size: 0.8vw;color: #c4ddf7;">
          <div style="margin-top: 18%;margin-left: 28%;">确认取消当前罐体的复查任务吗？
          </div>
        </div>
        <div
            style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
          <div class="newBtn1" style="width: 40%;" @click="cancelVisible = false">取消</div>
          <div class="newBtn1 newBtn1do" style="width: 40%;" @click="cancelTask">确认</div>
        </div>
      </div>
    </el-dialog>

    <!-- 图片放大 -->
    <el-dialog :visible.sync="ifPic" center class="img-user">
      <div>
        <img style="width: 88%" :src="picUrl" class="mapImg" >
      </div>
    </el-dialog>

    <!-- 完成任务-->
    <el-dialog :visible.sync="confirmVisible" width="30%" center>
      <div style="width: 100%;height: 100%;position: relative;">
        <img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">操作确认</div>
        </div>
        <div style="position: absolute;width: 100%;top: 1%;font-size: 0.8vw;color: #c4ddf7;">
          <div style="margin-top: 18%;margin-left: 28%;">确认完成当前罐体的复查任务吗？
          </div>
        </div>
        <div
            style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
          <div class="newBtn1" style="width: 40%;" @click="confirmVisible = false">取消</div>
          <div class="newBtn1 newBtn1do" style="width: 40%;" @click="confirmTask">确认</div>
        </div>
      </div>
    </el-dialog>

    <div style="display: flex;margin: 1%;margin-left: 1.5%;">
      <div class="indeBody-title">
        {{oilDetail.oilName}} | <span style="cursor: pointer" @click="toRobotDetail">{{oilDetail.robotName}}</span>
      </div>
      <div @click="confirmVisible = true" v-if="oilDetail.status=='1'" class="indeBody-btn blue">复查确认</div>
      <div @click="cancelVisible = true" v-if="oilDetail.status=='0'" class="indeBody-btn red">取消复查</div>
      <div @click="toIndex"  class="indeBody-btn blue">返回</div>

    </div>

    <div class="indeBody">
      <!-- 罐体阀门-->
      <div style="margin-left: 0.5%;text-align: left;position: relative;">
        <img style="height: 2vh;"  src="../../../static/imgV2/titleicon.png" >
        <span style="color: #fff;
                    position: absolute;
                    top: 0%;
                    left: 1%;
                    height: 2vh;
                    font-size: 0.8vw;"> 罐体阀门</span>
      </div>

      <div class="clearfix">
        <div class="indeBody-item" v-for="(obj, $index) in oilDetail.details.filter(res => res.valveType== '1')" :key="$index">
          <div class="indeBody-item-pic">
            <img  v-if="!obj.detailId" src="../../../static/imgV2/pic.png" >
            <img  v-else  @click="topic(obj.picUrl)" :src="obj.picUrl" >
            <div v-if="!obj.detailId" class="indeBody-item-pic-status huang">未巡检</div>
            <div v-if="obj.isError=='1'" class="indeBody-item-pic-status hong">异常</div>
            <div v-if="obj.isError=='0'" class="indeBody-item-pic-status lan">正常</div>
            <div class="indeBody-item-pic-name">{{ obj.deviceName }}</div>
          </div>
          <div class="indeBody-item-bottom">
            <div class="indeBody-item-bottom-left" >
              阀门状态：{{obj.deviceStatus=='1' ? '开' : '关'}}
              &nbsp;&nbsp; | &nbsp;&nbsp;
              <span v-if="obj.detailId" :class="obj.isError=='1' && 'error'">识别结果：{{obj.identifyStatus=='1' ? '开' : '关'}}</span>
              <span v-if="!obj.detailId">识别结果：无</span>
            </div>
            <div @click="updateResult(obj)" class="indeBody-item-bottom-right">更改</div>
          </div>
        </div>
      </div>

      <!-- 泵阀门-->
      <div style="margin-left: 0.5%;margin-top:1%;text-align: left;position: relative;">
        <img style="height: 2vh;"  src="../../../static/imgV2/titleicon.png" >
        <span style="color: #fff;
                    position: absolute;
                    top: 0%;
                    left: 1%;
                    height: 2vh;
                    font-size: 0.8vw;"> 泵阀门</span>
      </div>

      <div class="clearfix">
        <div class="indeBody-item" v-for="(obj, $index) in oilDetail.details.filter(res => res.valveType== '2')" :key="$index">
          <div class="indeBody-item-pic">
            <img  v-if="!obj.detailId" src="../../../static/imgV2/pic.png" >
            <img  v-else  @click="topic(obj.picUrl)" :src="obj.picUrl" >
            <div v-if="!obj.detailId" class="indeBody-item-pic-status huang">未巡检</div>
            <div v-if="obj.isError=='1'" class="indeBody-item-pic-status hong">异常</div>
            <div v-if="obj.isError=='0'" class="indeBody-item-pic-status lan">正常</div>
            <div class="indeBody-item-pic-name">{{ obj.deviceName }}</div>
          </div>
          <div class="indeBody-item-bottom">
            <div class="indeBody-item-bottom-left" >
              阀门状态：{{obj.deviceStatus=='1' ? '开' : '关'}}
              &nbsp;&nbsp; | &nbsp;&nbsp;
              <span v-if="obj.detailId" :class="obj.isError=='1' && 'error'">识别结果：{{obj.identifyStatus=='1' ? '开' : '关'}}</span>
              <span v-if="!obj.detailId">识别结果：无</span>
            </div>
            <div @click="updateResult(obj)" class="indeBody-item-bottom-right">更改</div>
          </div>
        </div>
      </div>

      <!-- 灯箱-->
      <div style="margin-left: 0.5%;margin-top:1%;text-align: left;position: relative;">
        <img style="height: 2vh;"  src="../../../static/imgV2/titleicon.png" >
        <span style="color: #fff;
                    position: absolute;
                    top: 0%;
                    left: 1%;
                    height: 2vh;
                    font-size: 0.8vw;"> 灯箱</span>
      </div>

      <div class="clearfix">
        <div class="indeBody-item" v-for="(obj, $index) in oilDetail.details.filter(res => res.valveType== '3')" :key="$index">
          <div class="indeBody-item-pic">
            <img  v-if="!obj.detailId" src="../../../static/imgV2/pic.png" >
            <img  v-else  @click="topic(obj.picUrl)" :src="obj.picUrl" >
            <div v-if="!obj.detailId" class="indeBody-item-pic-status huang">未巡检</div>
            <div v-if="obj.isError=='1'" class="indeBody-item-pic-status hong">异常</div>
            <div v-if="obj.isError=='0'" class="indeBody-item-pic-status lan">正常</div>
            <div class="indeBody-item-pic-name">{{ obj.deviceName }}</div>
          </div>
          <div class="indeBody-item-bottom">
            <div class="indeBody-item-bottom-left" >
              阀门状态：{{obj.deviceStatus=='1' ? '开' : '关'}}
              &nbsp;&nbsp; | &nbsp;&nbsp;
              <span v-if="obj.detailId" :class="obj.isError=='1' && 'error'">识别结果：{{obj.identifyStatus=='1' ? '开' : '关'}}</span>
              <span v-if="!obj.detailId">识别结果：无</span>
            </div>
            <div @click="updateResult(obj)" class="indeBody-item-bottom-right">更改</div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import RobotSocket from '@/components/RobotSocket.vue'
import Head from '@/components/Head.vue'
import {
  tankDetails,
  cancelTask,
  confirm,
  changeStatus,
} from '@/api/admin.js'
import {
  getItem,
  setToken,
  setItem,
  removeItem,
  removeToken
} from '@/utils/auth'

export default {
  name: "detail",
  components: {
    Head,
    RobotSocket,
  },
  data() {
    return {
      recordId: this.$route.query.recordId,
      ifPic:false,
      picUrl:null,
      cancelVisible:false,
      confirmVisible:false,
      ifWrong: false,
      statusMap:{"1":"调和","2":"灌装","3":"循环","4":"加热"},
      languageJson: languageJson,
      languageCheck: localStorage.getItem('language'),
      vSocketVos: {},
      nowTime: new Date().getTime(),
      tapType: false,
      dialogVisible: false,
      oilDetail:{}
    }
  },

  mounted() {
     this.getDetail();
  },


  methods: {
    toIndex(){
      this.$router.push({
        name: 'oil',
      })
    },
    getDetail(){
      tankDetails(this.recordId).then(res=>{
        console.log(res)
        this.oilDetail = res.data;
      })
    },
    toRobotDetail(){
      this.$router.push({
        name: 'detail',
        query: {
          robotId:this.oilDetail.robotId,
          type:'user'
        }
      })
    },
    topic(url){
      this.picUrl = url;
      this.ifPic = true;
    },
    updateResult(obj){
      if(!obj.detailId){
        this.$notify.error({
          title: '未巡检到当前阀门'
        })
        return
      }
      changeStatus(obj.detailId).then(res=>{
        obj.identifyStatus = obj.identifyStatus == '1' ? '0' : '1';
        obj.isError = obj.identifyStatus == obj.deviceStatus ? '0' : '1';
        this.$notify.success({
          title: '操作成功'
        })
      })
    },

    confirmTask(){
      confirm(this.recordId).then(res=>{
        this.confirmVisible = false
        this.$notify.success({
          title: '操作成功'
        })
        this.$router.push({ name: 'oil'})
      })
    },
    cancelTask(){
      cancelTask(this.recordId).then(res=>{
        this.cancelVisible = false
        this.$notify.success({
          title: '操作成功'
        })
        this.$router.push({ name: 'oil'})
      })
    },
    doSocker(socketData) {
      this.vSocketVos = socketData
      if (socketData.socketType == '30') {
        this.getDetail();
      }
    },
    changeTap(data) {
      this.tapType = data
    },
    headOut(data) {
      this.dialogVisible = true
    },
    getOut() {
      removeToken()
      removeItem('differtime')
      removeItem('loginSuccess')
      this.dialogVisible = false
      this.$router.push({
        name: 'login'
      })
    }
  },
  watch: {

  }
}
</script>

<style scoped lang="less">
@import "./detail.less";
</style>


// WEBPACK FOOTER //
// src/page/oil/detail.vue